export interface CategoryConfig {
  slug: string;
  displayName: string;
  icon: string;
  description: string;
}

/**
 * Master list of all 14 news categories.
 * Used for sidebar navigation, routing, and filtering.
 */
export const categories: CategoryConfig[] = [
  {
    slug: 'dashboard',
    displayName: 'Dashboard',
    icon: 'LayoutDashboard',
    description: 'Overview of today\'s mining intelligence across all categories.',
  },
  {
    slug: 'mining-companies',
    displayName: 'Mining Companies',
    icon: 'Factory',
    description: 'News and updates about mining companies operating across Africa.',
  },
  {
    slug: 'market-insights',
    displayName: 'Market Insights',
    icon: 'TrendingUp',
    description: 'Market analysis, trends, and investment intelligence for the mining sector.',
  },
  {
    slug: 'commodities',
    displayName: 'Commodities',
    icon: 'Gem',
    description: 'Price movements, supply-demand dynamics, and commodity-specific news.',
  },
  {
    slug: 'africa-focus',
    displayName: 'Africa Focus',
    icon: 'Globe',
    description: 'Strategic intelligence from the African continent\'s mining landscape.',
  },
  {
    slug: 'financial-results',
    displayName: 'Financial Results',
    icon: 'DollarSign',
    description: 'Quarterly and annual financial results from major mining companies.',
  },
  {
    slug: 'financing',
    displayName: 'Financing',
    icon: 'Banknote',
    description: 'Funding rounds, debt issuance, equity raises, and capital markets activity.',
  },
  {
    slug: 'infrastructure',
    displayName: 'Infrastructure',
    icon: 'TrainFront',
    description: 'Mining infrastructure, logistics, ports, rail, and energy developments.',
  },
  {
    slug: 'regulatory',
    displayName: 'Regulatory',
    icon: 'ScrollText',
    description: 'Mining regulations, policy changes, and compliance updates across jurisdictions.',
  },
  {
    slug: 'legal-taxes-royalties',
    displayName: 'Legal & Taxes',
    icon: 'Scale',
    description: 'Legal disputes, tax rulings, royalty frameworks, and fiscal policy.',
  },
  {
    slug: 'artisanal-mining',
    displayName: 'Artisanal Mining',
    icon: 'Pickaxe',
    description: 'Artisanal and small-scale mining (ASM) developments and formalization efforts.',
  },
  {
    slug: 'government-figures',
    displayName: 'Government Data',
    icon: 'Building2',
    description: 'Official government statistics, production data, and policy announcements.',
  },
  {
    slug: 'consultancy-reports',
    displayName: 'Reports & Studies',
    icon: 'FileText',
    description: 'Industry reports, consultancy studies, and research publications.',
  },
  {
    slug: 'internal-reports',
    displayName: 'Internal Reports',
    icon: 'Upload',
    description: 'Proprietary StratMined reports and internal analysis documents.',
  },
];

/**
 * Get a category by its slug.
 */
export function getCategoryBySlug(slug: string): CategoryConfig | undefined {
  return categories.find((c) => c.slug === slug);
}

/**
 * Get all navigable categories (excluding dashboard which is a special route).
 */
export function getNavigableCategories(): CategoryConfig[] {
  return categories.filter((c) => c.slug !== 'dashboard');
}
